import { PrimitiveBlueprint } from "../types";
import { AVATAR_SIZE_CLASSES } from "./sizeClasses";
import { PRIMITIVE_COLORS } from "../../constants";

const CHEST_COLORS = {
  body: PRIMITIVE_COLORS.amber,
  lid: PRIMITIVE_COLORS.yellow,
  band: PRIMITIVE_COLORS.stone,
  lock: PRIMITIVE_COLORS.slate,
  lockDetail: PRIMITIVE_COLORS.darkSlate,
  border: PRIMITIVE_COLORS.stone,
  highlight: PRIMITIVE_COLORS.lightYellow,
  shadow: PRIMITIVE_COLORS.darkSlate,
};

export const CHEST_BLUEPRINT: PrimitiveBlueprint = {
  id: "chest",
  designSize: AVATAR_SIZE_CLASSES.MEDIUM,
  parts: [
    // Shadow
    {
      id: "shadow",
      type: "ellipse",
      bounds: { x: 0.1, y: 0.85, w: 0.8, h: 0.12 },
      style: { fill: CHEST_COLORS.shadow, fillAlpha: 0.3 },
      z: 0,
    },
    // Chest body (main box)
    {
      id: "body",
      type: "roundRect",
      bounds: { x: 0.2, y: 0.5, w: 0.6, h: 0.4 },
      style: {
        fill: CHEST_COLORS.body,
        stroke: CHEST_COLORS.border,
        strokeWidth: 4,
      },
      z: 1,
    },
    // Chest lid (top)
    {
      id: "lid",
      type: "roundRect",
      bounds: { x: 0.2, y: 0.3, w: 0.6, h: 0.25 },
      style: {
        fill: CHEST_COLORS.lid,
        stroke: CHEST_COLORS.border,
        strokeWidth: 4,
      },
      z: 2,
    },
    // Decorative band across lid
    {
      id: "band",
      type: "rect",
      bounds: { x: 0.25, y: 0.38, w: 0.5, h: 0.1 },
      style: {
        fill: CHEST_COLORS.band,
        stroke: CHEST_COLORS.border,
        strokeWidth: 2,
      },
      z: 3,
    },
    // Lock/keyhole (center decoration)
    {
      id: "lock",
      type: "circle",
      bounds: { x: 0.4, y: 0.42, w: 0.2, h: 0.2 },
      style: {
        fill: CHEST_COLORS.lock,
        stroke: CHEST_COLORS.border,
        strokeWidth: 2,
      },
      z: 4,
    },
    // Keyhole detail
    {
      id: "keyhole",
      type: "rect",
      bounds: { x: 0.47, y: 0.44, w: 0.06, h: 0.1 },
      style: { fill: CHEST_COLORS.lockDetail },
      z: 5,
    },
    // Highlight on lid (shine effect)
    {
      id: "highlight",
      type: "ellipse",
      bounds: { x: 0.3, y: 0.35, w: 0.3, h: 0.15 },
      style: { fill: CHEST_COLORS.highlight, fillAlpha: 0.4 },
      z: 3,
    },
  ],
};
